// extracted by mini-css-extract-plugin
export default {"card":"notFound_card__ooZLM","txt":"notFound_txt__ooNVO","boxImg":"notFound_boxImg__Tueu-","img":"notFound_img__hCyJN","bodyTxt":"notFound_bodyTxt__05Ans"};